import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 列表查询-责任人信息查询
export const neoCrmRespChangeQuery = (data) => {
    return request({
        url: apiCrmHost + '/neoCrm/respChange/query',
        method: 'post',
        data
    });
};
// 列表查询-责任人变更记录查询
export const neoCrmRespDetailQuery = (data) => {
    return request({
        url: apiCrmHost + '/neoCrm/respDetail/query',
        method: 'post',
        data
    });
};
// 变更明细保存
export const neoRespChangeSave = (data) => {
    return request({
        url: apiCrmHost + '/neo/respChange/save',
        method: 'post',
        data
    });
};
// 变更明细删除
export const neoRespChangeDelete = (data) => {
    return request({
        url: apiCrmHost + '/neoCrm/respChange/delete',
        method: 'post',
        data
    });
};
// 收入分摊-保存
export const saveSharingRules = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/create',
        method: 'post',
        data
    });
};
// 收入分摊-更新
export const updateSharingRules = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/update/remark',
        method: 'post',
        data
    });
};
// 收入分摊-分摊规则查询
export const queryDetailInfo = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/query',
        method: 'post',
        data
    });
};
// 收入分摊-分摊规则查询
export const queryDetailList = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/detail/query/page',
        method: 'post',
        data
    });
};
// 收入分摊-分摊规则更新
export const addDetailList = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/detail/add',
        method: 'post',
        data
    });
};
// 收入分摊-分摊规则删除
export const delDetailList = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/detail/del',
        method: 'post',
        data
    });
};
// 收入分摊-导出
export const sharingRulesExport = (params) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/export',
        method: 'get',
        params
    });
};
// 收入分摊-导入
export const sharingRulesImport = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/import',
        method: 'post',
        data
    });
};
// 收入分摊-提交审批
export const sharingRulesSubmit = (params) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/submit',
        method: 'get',
        params
    });
};
// 收入分摊-附件导入
export const sharingRulesFileImport = (data) => {
    return request({
        url: apiCrmHost + '/contractEnclosureInfo/upload/common',
        method: 'post',
        data
    });
};
// 收入分摊-附件删除
export const sharingFileDel = (data) => {
    return request({
        url: apiCrmHost + '/contractEnclosureInfo/del/common',
        method: 'post',
        data
    });
};
// 收入分摊-权限控制
export const getCurrentUserRole = (params) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/get/role',
        method: 'get',
        params
    });
};
// 收入分摊-变更明细表更新
export const updateDetailList = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/detail/update',
        method: 'post',
        data
    });
};
// 收入分摊-提交审批校验
export const sharingRulesCheck = (params) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/submit/verify',
        method: 'get',
        params
    });
};

// 客户负责人归档信息-退出报告特权角色判断 zrq
export const getCurrentPrivilegeRole = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/page/auth/dictShow',
        method: 'post',
        data
    });
};
// 客户负责人归档信息-批量更新生效日期 zrq
export const updateEffectDate = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/flow/detail/effectDate',
        method: 'post',
        data
    });
};
// 客户负责人归档信息-特权角色 zrq
export const getCurrentPrivilege = (params) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/isPrivileged',
        method: 'get',
        params
    });
};
